<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} income-exit-balance-of-irr-widget" *ngIf="widgetData">
    <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-large">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>

          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>

          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>

          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="12" class="widget-content">
            <table class="widget-ruller noheight widgetIncomeExitBalanceOfIrr" aria-hidden="true">
              <thead>
                <tr class="widget-ruller-flex noheight">
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>

                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                  <th scope="col" class="widget-grid-column">&nbsp;</th>
                </tr>
              </thead>
              <tr class="white-line">
                <td colspan="19"><widget-value [align]="'left'" [bold]="true">{{'incomeExitBalanceOfIrr.labelTitle' | rdTranslate}}</widget-value></td>
              </tr>
              <tr class="white-line">
                <td colspan="19">&nbsp;</td>
              </tr>
              <tr class="white-line">
                <td colspan="10"><widget-value [align]="'left'">{{'incomeExitBalanceOfIrr.netOperatingIncome' | rdTranslate}}</widget-value></td>
                <td colspan="9"><widget-value [widget]="this" [fieldName]="'netOperatingIncome'" [align]="'right'">{{ (widgetData.netOperatingIncome || 0) | rdLocalizedNumber:0 }} </widget-value></td>
              </tr>
              <tr class="white-line">
                <td colspan="10"><widget-value [align]="'left'">{{'incomeExitBalanceOfIrr.terminalValue' | rdTranslate}}</widget-value></td>
                <td colspan="9"><widget-value [widget]="this" [fieldName]="'terminalValue'" [align]="'right'">{{ (widgetData.terminalValue || 0) | rdLocalizedNumber:0 }} </widget-value></td>
              </tr>
              <tr class="white-line total-line">
                <td colspan="10"><widget-value [align]="'left'">{{'incomeExitBalanceOfIrr.total' | rdTranslate}}</widget-value></td>
                <td colspan="9" class="total-value"><widget-value [widget]="this" [fieldName]="'total'" [align]="'right'">{{ (widgetData.total || 0) | rdLocalizedNumber:0 }} </widget-value></td>
              </tr>
            </table>
          </td>

          <td colspan="1" class="space">&nbsp;</td>
          <td colspan="20" style="height: 100%;">
            <div class="k-donut-chart-container-print-fix" style="height: 200px !important; width: 315px !important;">
              <div class="k-donut-chart-wrapper" *ngIf="chartReady">
                <kendo-chart class="k-donut-chart-area" [transitions]="chartTransitionsEnabled">
                  <kendo-chart-area background="none"></kendo-chart-area>

                  <ng-template kendoChartDonutCenterTemplate>
                  </ng-template>

                  <kendo-chart-series>
                    <kendo-chart-series-item type="pie" [data]="widgetData.entries" categoryField="label" field="value"
                                             [color]="getColor" [size]="20" [autoFit]="false">
                      <kendo-chart-series-item-labels position="outsideEnd"
                                                      color="#000"
                                                      font="normal normal 700 14px Arial"
                                                      [content]="chartLabelContent">
                      </kendo-chart-series-item-labels>
                    </kendo-chart-series-item>
                  </kendo-chart-series>

                  <kendo-chart-legend [visible]="true" [position]="'bottom'" [labels]="{color: '#000000', font: '12px Arial'}">
                  </kendo-chart-legend>
                </kendo-chart>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tr><td class="space">&nbsp;</td></tr>
      <tr><td class="space">&nbsp;</td></tr>
    </table>
</div>
